export default __webpack_public_path__ + "static/media/user.b0fd954c.svg";